import { render, staticRenderFns } from "./Directorys.vue?vue&type=template&id=4b4f30f2&"
import script from "./Directorys.vue?vue&type=script&lang=js&"
export * from "./Directorys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports